module.exports = __webpack_public_path__ + "static/media/linkedin.e0695d69.png";